export function mapFeedData(feeds: any[]) {
  return feeds.map(feed => ({
    ...feed,
    unix_timestamp: Number.isInteger(feed.unix_timestamp) ? feed.unix_timestamp : parseInt(feed.unix_timestamp)
  }))
}